import { Controller } from "@hotwired/stimulus"
import { showNotification } from "./helpers"

export default class extends Controller {
  static targets = ["periodMoreField", "searchFilters", "searchFiltersToggleText", "searchFiltersArrow", "searchField", "exactCheckbox", "exactCheckboxWrapper",
    "searchForm", "searchFormAction"
  ]

  static values = { showMore: String, showLess: String }
  static classes = ["rotate"]

  toggleSearchFilters() {
    this.searchFiltersTarget.classList.toggle("hidden")
    this.searchFiltersArrowTarget.classList.toggle(this.rotateClass)
    this.searchFiltersToggleTextTarget.innerText = this.searchFiltersTarget.classList.contains("hidden") ? this.showMoreValue : this.showLessValue
  }

  onQueryChange() {
    const shouldDisplayExact = this.searchFieldTarget.value.length >= 3
    if (shouldDisplayExact) {
      this.exactCheckboxWrapperTarget.classList.remove("hidden")
    } else {
      this.exactCheckboxWrapperTarget.classList.add("hidden")
      this.exactCheckboxTarget.checked = false
    }
  }

  onPeriodChange(event) {
    if (event.target.value === "more") {
      event.target.parentNode.classList.add("hidden")
      for (const element of this.periodMoreFieldTargets) {
        element.classList.remove("hidden")
        for (const child of element.querySelectorAll("[disabled]")) {
          child.disabled = false
        }
      }
    }
  }

  // Import wydatków z KSeF: POST na dedykowany endpoint przez współdzielony #bulk_action_form
  // (globalny token CSRF, bez zależności od jQuery). import_ksef nie operuje na zaznaczonych fakturach.
  importKsef(event) {
    const url = event?.params?.url
    const form = document.getElementById("bulk_action_form")

    if (!url || !form) {
      showNotification("Wystąpił problem z importem z KSeF")
      return
    }

    form.action = url
    const methodInput = form.querySelector("input[name=\"_method\"]")
    if (methodInput) methodInput.value = "post"
    form.submit()
  }
}
